'use client';
import styles from './500.module.scss';
import { Button, Result } from 'antd';
import Image from 'next/image';
import errorStateLight from 'assets/images/results/500-light.svg';
import errorStateDark from 'assets/images/results/500-dark.svg';
import { useContext } from 'react';
import { GlobalContext } from 'context';
import { useRouter } from 'next/navigation';
import { ThemeEnum } from 'types';

const Error500Comp: React.FC<{ reset: () => void; error?: any }> = (props) => {
    const { theme } = useContext(GlobalContext);
    const router = useRouter();

    return (
        <div className={`flex-column`}>
            <div className={`${styles['container']}`}>
                <Result
                    icon={
                        <Image
                            className={styles.image}
                            src={theme === ThemeEnum.dark ? errorStateDark : errorStateLight}
                            alt="error image"
                        />
                    }
                    className="pv-0"
                    title={'خطایی به وجود آمده است'}
                    subTitle={'لطفا کمی بعد مجددا اقدام نمایید'}
                    extra={
                        <>
                            <Button
                                key={'sada'}
                                type="default"
                                size="small"
                                className="ph-2-i"
                                onClick={() => router.back()}
                            >
                                بازگشت
                            </Button>
                            <Button
                                key={'0asdf0'}
                                type="primary"
                                size="small"
                                className="ph-2-i"
                                onClick={() => props.reset()}
                            >
                                تلاش مجدد
                            </Button>
                        </>
                    }
                />
            </div>
        </div>
    );
};
export default Error500Comp;
